import React from "react";

import Html from "./Html";
import { Provider } from "./Provider";
import DateFilter from "./components/dateFilter";

const FtmRatings = () => {
    return(
        <Provider>
            <Html/>
            <DateFilter/>
        </Provider>
    )
} 

export default FtmRatings;